import * as Factory from 'factory.ts'
import faker from 'faker'

import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import {
  ExpensePermissions,
  type ExpensePermissionsConstructor,
} from './ExpensePermissions'

export const ExpensePermissionsConstructorFactory =
  Factory.Sync.makeFactory<ExpensePermissionsConstructor>({
    canEdit: Factory.each(() => faker.random.boolean()),
    canDelete: Factory.each(() => faker.random.boolean()),
    canApprove: Factory.each(() => faker.random.boolean()),
    canRevise: Factory.each(() => faker.random.boolean()),
  })

export const ExpensePermissionsFactory = EntityFactory(
  ExpensePermissions,
  ExpensePermissionsConstructorFactory
)
